const PLAYER_KEY = '_ml_pid';

export function getWebPlayerId(): string {
  try {
    const existing = localStorage.getItem(PLAYER_KEY);
    if (existing) {
      return existing;
    }
    const id =
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? `web_${crypto.randomUUID()}`
        : `web_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(PLAYER_KEY, id);
    return id;
  } catch {
    return 'web_anonymous';
  }
}
